import { Icon, type IconTone } from './Icon';

/** Кружок с «i»: плашка-подсказка, а не предупреждение. */
export function InfoIcon({ size = 16, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={16} tone={tone}>
      <circle cx="8" cy="8" r="6.6" strokeWidth={1.2} />
      <path d="M8 7 v4.2" strokeWidth={1.2} />
      <path d="M8 4.6 v1.2" strokeWidth={1.2} />
    </Icon>
  );
}
